export const isAccessDeniedError = (error) => {
    return /Access denied/i.test(error.message);
};
